export default __webpack_public_path__ + "static/design_mobile-poster-9740eca25bbdb3ea39236def98783480.avif";